import { AppConfig } from "../types/app-config";
import servicesUtils from "../utils/servicesUtils";
import Store from "../utils/Store";

export const getUserSettings = async () => {
  const settingsData: any = await servicesUtils.getService("/settings/");
  Store.update((store) => {
    // eslint-disable-next-line no-param-reassign
    store.userSettings = settingsData && settingsData.settings ? settingsData : {};
  });
};

export const getAppConfig = async () => {
  const configData = await servicesUtils.getService<AppConfig>("/configs/");
  Store.update((store) => {
    // eslint-disable-next-line no-param-reassign
    store.appConfig = configData || {};
  });
  return configData;
};

export const postFormImport = async (params: any) => {
  const formImportData = await servicesUtils.postService("/forms/import/", params);
  return formImportData;
};

export const getFormExportNames = async (workspaceId: number) => {
  const formNames = await servicesUtils.getService(
    `/workspaces/${workspaceId}/forms/export/names/`
  );
  return formNames;
};

export const getFormExportJson = async (workspaceId: number, formName: string) => {
  const formData = await servicesUtils.getService(
    `workspaces/${workspaceId}/forms/${formName}/export/schema/`
  );
  return formData;
};
